import { getCurrentInstance, computed, unref } from '@vue/composition-api'

export default function useRouter () {
  const { proxy } = getCurrentInstance()
  const route = computed(() => proxy.$route)
  const router = computed(() => proxy.$router)
  return { route, router }
}

/**
 * @param {string} key
 */
export function useRouteParam (key) {
  const { route } = useRouter()
  return computed(() => unref(route).params[key])
}

/**
 * @param {string} key
 */
export function useRouteQuery (key) {
  const { route } = useRouter()
  return computed(() => unref(route).query[key])
}

/**
 * @returns {ComputedRef<string>}
 */
export function useRouteParamId () {
  return useRouteParam('id')
}
